import {createUseStyles} from 'react-jss';
import Spinner from '../../../../v2/components/ui/Spinner';
import Translation from '../../../../v2/lang/Translation';

const useStyles = createUseStyles(
  {
    createAccountPending: {
      padding: 40,
      margin: [0, 'auto'],
      textAlign: 'center',
    },

    title: {
      marginBottom: 20,
    },
  },
);

function CreateAccountPending() {
  const classes = useStyles();
  return (
    <div className={classes.createAccountPending}>
      <h3 className={classes.title}>
        <Translation>creating.account</Translation>
        ...
      </h3>
      <Spinner size="small" />
    </div>
  );
}

export default CreateAccountPending;
